<template>
  <div>
    <h3>
      {{ $t('month-at-a-glance') }}
    </h3>
    <div class="row">
      <div class="col-12 col-md-6">
        <table class="table tabled-bordered">
          <thead>
          <tr>
            <th colspan="2">
              {{ $t('number-permits-issued') }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
            {{ $t('residential') }}
            </td>
            <td>
            {{ residential }}
            </td>
          </tr>
          <tr>
            <td>
            {{ $t('non-residential') }}
            </td>
            <td>
            {{ nonResidential }}
            </td>
          </tr>
          <tr>
            <td>
            {{ $t('total') }}
            </td>
            <td>
            {{ residentialTotal }}
            </td>
          </tr>
          <tr>
            <td>
            {{ $t('compared-to-last-year') }}
            </td>
            <td>
              {{ last_year_permit_pct | percent($LANG) }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12 col-md-6">
        <table class="table tabled-bordered">
          <thead>
          <tr>
            <th colspan="2">
              {{ $t('value-permits-issued') }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
            {{ $t('residential') }}
            </td>
            <td>
            {{ vresidential | currencyFull($LANG) }}
            </td>
          </tr>
          <tr>
            <td>
            {{ $t('non-residential') }}
            </td>
            <td>
            {{ vnonResidential | currencyFull($LANG)  }}
            </td>
          </tr>
          <tr>
            <td>
            {{ $t('total') }}
            </td>
            <td>
            {{ vresidentialTotal | currencyFull($LANG)  }}
            </td>
          </tr>
          <tr>
            <td>
            {{ $t('compared-to-last-year') }}
            </td>
            <td>
              {{ last_year_value_pct | percent($LANG) }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12 col-md-6">
        <table class="table tabled-bordered">
          <thead>
          <tr>
            <th colspan="2">
              {{ $t('dwelling-units') }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
            {{ $t('constructed') }}
            </td>
            <td>
            {{ dw_gained }}
            </td>
          </tr>
          <tr>
            <td>
            {{ $t('demolished') }}
            </td>
            <td>
            {{ dw_lost }}
            </td>
          </tr>
         </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: "GlanceTable",

  props: {
    startDate: String,
    endDate: String,
  },

  data() {
    return {
      response01: [],
      response02: [],
    }
  },

  created() {
    this.fetchData();
  },

  watch: {
    endDate() {
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      const startDate = this.startDate;
      const endDate = this.endDate;
      // By Residential Category
      const request01 = axios.get(
        `${this.$PERMIT_API}?$select=residential_category,sum(permit_count) as total_permit,sum(declared_construction_value) as total_value&$where=issue_date='${endDate}'&$group=residential_category`
      );
      // Totals (permits, value, dwelling units gained and lost, last year pcts)
      const request02 = axios.get(
        `${this.$PERMIT_API}?$select=sum(case(issue_date='${endDate}',permit_count,true,0)) as total_permits, sum(case(issue_date='${endDate}',declared_construction_value,true,0)) as total_value, sum(case(issue_date='${endDate}',dwelling_units_created,true,0)) as dw_gained, sum(case(issue_date='${endDate}',dwelling_units_lost,true,0)) as dw_lost, round(100*(sum(case(issue_date='${endDate}', permit_count, true, 0))/sum(case(issue_date='${startDate}', permit_count, true, 0)) - 1), 0) as last_year_permit_pct, round(100*(sum(case(issue_date='${endDate}', declared_construction_value, true, 0))/sum(case(issue_date='${startDate}', declared_construction_value, true, 0)) - 1), 0) as last_year_value_pct&$where=(issue_date='${endDate}') or (issue_date='${startDate}')`
      );

      const self = this;
      axios
        .all([
          request01,
          request02,
        ])
        .then(
          axios.spread(function (
            response01,
            response02,
          ) {
            self.response01 = response01.data;
            self.response02 = response02.data;
          })
        );
    }
  },

  computed: {
    residential: function () {
      if (this.response01.length === 0) return 0;
      return this.response01[0].total_permit;
    },
    nonResidential: function () {
      if (this.response01.length === 0) return 0;
      return this.response01[1].total_permit;
    },
    residentialTotal: function () {
      if (this.response02.length === 0) return 0;
      return this.response02[0].total_permits;
    },
    last_year_permit_pct: function () {
      if (this.response02.length === 0) return 0;
      return this.response02[0].last_year_permit_pct;
    },
    last_year_value_pct: function () {
      if (this.response02.length === 0) return 0;
      return this.response02[0].last_year_value_pct;
    },
    vresidential: function () {
      if (this.response01.length === 0) return 0;
      return this.response01[0].total_value;
    },
    vnonResidential: function () {
      if (this.response01.length === 0) return 0;
      return this.response01[1].total_value;
    },
    vresidentialTotal: function () {
      if (this.response02.length === 0) return 0;
      return this.response02[0].total_value;
    },
    dw_gained: function () {
      if (this.response02.length === 0) return 0;
      return this.response02[0].dw_gained;
    },
    dw_lost: function () {
      if (this.response02.length === 0) return 0;
      return this.response02[0].dw_lost;
    },
  },
};
</script>

<style scoped>
</style>
